import { platform } from './src/index.js';
import * as random from './src/browser/random.js';
import * as jwt from './src/browser/jwt.js';
export { AuthFlowError } from './src/error.js';
const { redirectToLogin, processLoginResult, isAuthorized, refreshTokens, logout } = platform({ random, jwt });
export { redirectToLogin, processLoginResult, isAuthorized, refreshTokens, logout };
